import AppointmentAttendancePills from './AppointmentAttendancePills';

export default AppointmentAttendancePills;
